/** @jsx jsx */
import { Box, Button, jsx } from 'theme-ui';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import { RichText } from 'prismic-reactjs';
import { ArrowRight } from '../icons';
import Carousel from '../carousel/carousel';
import ScBlock from '../sc-block/sc-block';
import styles from './sc-banner.style';
import { Link } from "gatsby";
import { RiHandHeartLine, RiPlantLine } from "react-icons/ri";
import { FaSprayCan } from "react-icons/fa";
import { GiHerbsBundle } from "react-icons/gi";
/*type Props = {
	data: any;
	scrollTo?: string;
	scrollOffset?: number;
};*/
import sc_img_1 from "../../images/sc-banner/normal.jpg"
import sc_img_2 from "../../images/sc-banner/chemical-free.jpg"
import sc_img_3 from "../../images/sc-banner/organic.jpg"

const Spray = <FaSprayCan/>
const Chem = <GiHerbsBundle/>
const Organic = <RiHandHeartLine/>

const data = [
	{
		icon: Spray,	  
		image_url: sc_img_1,
		title: "Normal",
		subTitle: "No control on application of chemical fertilizers and pesticides",
		path: "/collection/normal",
	},
	{
		icon: Chem,	  
		image_url: sc_img_2,
		title: "Chemical Free", 
		subTitle: "Application of chemical fertilizers is ceased 10-15 days before harvesting. Without chemical pesticides",				
		path: "/collection/chemical-free",	
	},	
	{  
		icon: Organic,	
		image_url: sc_img_3,
		title: "Organic",	
		subTitle: "Natural processes. Without application of chemical fertilizers and pesticides",
		path: "/collection/organic",					
	}	
]

const ScBanner: React.FC<Props> = ({ scrollTo, scrollOffset }) => {
	const responsive = {
		ipad: {
			breakpoint: { max: 100000, min: 651 },
			items: 2,
		},
		mobile: {
			breakpoint: { max: 650, min: 0 },
			items: 1,
		},
	};

	return (
		<Box className="picksyAdBanner" sx={styles.wrapper}>
			<Carousel ssr={true} responsive={responsive} gutter="10px" autoPlay={true} autoPlaySpeed={3000} >
				{data.map((item: any, index: number) => (
					<ScBlock
						key={`scblock-key${index}`}
						bannerImage={item.image_url}
						icon={item.icon}
						title={item.title}
						subTitle={item.subTitle}
						path={item.path}
					/>
				))}
			</Carousel>
		</Box>
	);
};

export default ScBanner;
